import React, { useRef } from "react";
import { ChevronRight } from "lucide-react";
import { brands } from "../mock";
import { SectionTitle } from "./ShopByAge";

const brandClass = {
  lego: "font-display font-extrabold tracking-tight bg-gray-400 text-white px-3 py-1 rounded-md text-lg",
  script: "italic font-bold text-2xl",
  serif: "font-serif font-bold text-xl",
  "bold-italic": "font-display font-extrabold italic tracking-widest text-xl",
  flame: "font-display font-extrabold italic text-lg uppercase",
  rounded: "font-display font-bold text-xl",
  lower: "font-display font-bold lowercase text-xl tracking-wide",
  chicco: "font-display font-extrabold lowercase text-xl px-3 py-1 bg-gray-400 text-white rounded-full",
};

const TopBrands = () => {
  const rowRef = useRef(null);
  const scrollRight = () => rowRef.current?.scrollBy({ left: 280, behavior: "smooth" });

  return (
    <section className="py-10 md:py-14 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <SectionTitle>Top Brands</SectionTitle>
        <div className="relative">
          <div className="bg-[#F7F7FA] rounded-2xl border border-gray-100 px-6 py-6">
            <div ref={rowRef} className="flex items-center gap-10 md:gap-14 overflow-x-auto no-scrollbar justify-start lg:justify-between">
              {brands.map((b) => (
                <span
                  key={b.name}
                  className={`shrink-0 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer select-none ${brandClass[b.style]}`}
                >
                  {b.name}
                </span>
              ))}
            </div>
          </div>
          <button
            onClick={scrollRight}
            className="absolute -right-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white shadow-lg border border-gray-100 flex items-center justify-center hover:scale-110 transition-transform lg:hidden"
            style={{ color: "#1B1F5C" }}
            aria-label="Scroll brands"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TopBrands;
